import { motion } from "framer-motion";

/**
 * Fade-up reveal on scroll. Wrap any element to give it an editorial
 * "appearing on the page" feel as the reader scrolls. No-op for users
 * with reduced-motion preferences (framer-motion handles that internally).
 */
export default function Reveal({ children, delay = 0, y = 18, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
